import { render, staticRenderFns } from "./LicenseBy.vue?vue&type=template&id=d2ed40fe"
import script from "./LicenseBy.vue?vue&type=script&lang=js"
export * from "./LicenseBy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports